import React from "react";
import {
  CardContent,
  Typography,
  Box,
  Stack,
  Tooltip,
  IconButton,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import BusinessIcon from "@mui/icons-material/Business";
import StatusChip from "../common/StatusChip";
import { StyledCard } from "../common/StyledCard";
import InfoRow from "../common/InfoRow";
import { BranchSummaryDto } from "../../shared/dtos/branch/BranchSummaryDto";
import { BranchResponseDto } from "../../shared/dtos/branch/BranchResponseDto";

interface BranchCardProps {
  branch: BranchSummaryDto | BranchResponseDto;
  onView?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
}

const BranchCard: React.FC<BranchCardProps> = ({
  branch,
  onView,
  onEdit,
  onDelete,
}) => (
  <StyledCard>
    <CardContent
      sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}
    >
      {/* Header */}
      <Stack
        direction="row"
        sx={{
          justifyContent: "space-between",
          alignItems: "flex-start",
          mb: 1,
        }}
      >
        <Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {branch.name}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
              fontWeight: 500,
              display: "block",
            }}
          >
            CODE: {branch.branchCode}
          </Typography>
        </Box>
        <Stack direction="row">
          {onView && (
            <Tooltip title="View Details">
              <IconButton onClick={onView} size="small" color="info">
                <VisibilityOutlinedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
          {onEdit && (
            <Tooltip title="Edit Branch">
              <IconButton onClick={onEdit} size="small" color="secondary">
                <EditOutlinedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
          {onDelete && (
            <Tooltip title="Delete Branch">
              <IconButton onClick={onDelete} size="small" color="error">
                <DeleteOutlineIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      </Stack>

      {/* Body */}
      <Stack spacing={1.5} sx={{ mt: 2, flexGrow: 1 }}>
        <InfoRow
          icon={<BusinessIcon fontSize="small" />}
          label="Principal"
          value={branch.principalName || "N/A"}
        />
        <Box sx={{ mt: "auto", pt: 1 }}>
          <StatusChip status={branch.branchStatus} />
        </Box>
      </Stack>
    </CardContent>
  </StyledCard>
);

export default BranchCard;
